import { TActState } from "views/services/banner";
import { MonthsLan } from "./language/texts";

/**
 * 将时间戳转换为日月年 （13 January 2008）
 * @param timeStamp 时间戳
 */
export const formatDate = (timeStamp: number, language: string = "en"): string => {
	const date: Date = new Date(timeStamp);
	const monthArr: string[] = MonthsLan[language] || MonthsLan["en"];
	const year: string = date.getFullYear().toString();
	const month: string = monthArr[date.getMonth()];
	const day: string = date.getDate().toString();

	switch (language) {
		case "es":
		case "pt":
			return `${day} de ${month} de ${year}`;
		default:
			return `${day} ${month} ${year}`;
	}
};

/**
 * 将接口返回的 left 转换为时分秒 （["33", "22", "10"]）
 * @param leftTime 接口返回的 left 字段
 */
export const formatMinutesAndSeconds = (leftTime: number, state: TActState): string[] => {
	if (leftTime > -1) {
		const onlyOnGoing =
			state === TActState.OnGoing ? EnFormateDays(leftTime) * SECONDS_IN_A_DAY : 0;
		const newTime = leftTime - onlyOnGoing;
		let hour: string = Math.floor(newTime / 3600).toString();
		let min: string = (Math.floor(newTime / 60) % 60).toString();
		let sec: string = (newTime % 60).toString();

		return [hour, min, sec].map((item) => {
			if (+item < 10) {
				item = "0" + item;
			}
			return item;
		});
	}
	return [];
};

export const secToTimeArr = (leftTime: number) => {
	let result = {
		hour: "",
		min: "",
		sec: "",
	};
	if (leftTime > -1) {
		let hour = Math.floor(leftTime / 3600).toString();
		let min = (Math.floor(leftTime / 60) % 60).toString();
		let s = (leftTime % 60).toString();
		if (Number(hour) < 10) {
			hour = "0" + hour;
		}
		result.hour = hour;
		if (Number(min) < 10) {
			min = "0" + min;
		}
		result.min = min;
		if (Number(s) < 10) {
			s = "0" + s;
		}
		result.sec = s;
	}
	return result;
};

export const SECONDS_IN_A_DAY = 24 * 60 * 60;

export const EnFormateDays = (sec: number) => {
	if (sec && sec > 0) {
		return Math.floor(sec / SECONDS_IN_A_DAY);
	}
	return 0;
};

export const endUnit = (language: string = "en") => {
	switch (language) {
		case "no":
			return "Dager";
		case "pt":
			return "Dias";
		case "es":
			return "Días";
		case "de":
			return "Tag";
		default:
			return "days";
	}
};
